import Vue from 'vue';
import Router from 'vue-router';
// import PlaneAnim from '@/components/PlaneAnim'
import MainView from '@/components/Pages/MainView';
import VueAnalytics from 'vue-analytics';
import CommercialPlaneAnim from '../components/PlaneAnims/CommercialPlaneAnim.vue';
import ResidentialPlaneAnim from '../components/PlaneAnims/ResidentialPlaneAnim.vue';

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'MainView',
      component: MainView
    },
    {
      path: '/commercial',
      name: 'CommercialPlaneAnim',
      component: CommercialPlaneAnim
    },
    {
      path: '/residential',
      name: 'ResidentialPlaneAnim',
      component: ResidentialPlaneAnim
    },
    {
      path: '/thanks',
      name: 'Thanks',
      component: MainView
    }
  ]
});

if (process.env.NODE_ENV === 'production') {
  Vue.use(VueAnalytics, {
    id: 'UA-126207930-1',
    router
  });
}

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js